<template>
  <div>
    <v-dialog
      v-model="addEditOrderCaseModal"
      persistent
      max-width="500px"
    >
      <v-card>
        <form @submit.prevent="submitForm()">
          <v-card-title class="pb-0">
            <v-flex
              xs11
              sm10
              md10
            >
              <span class="headline">
                {{ isUpdate ? 'Update Order Case' : 'Add New Order Case' }}
              </span>
            </v-flex>
            <v-flex
              xs1
              sm2
              md2
            >
              <v-btn
                flat
                @click="closeDialog()"
                class="close"
              >
                <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span>
              </v-btn>
            </v-flex>
          </v-card-title>
          <v-card-text v-if="addEditOrderCaseModal">
            <v-layout wrap>
              <v-flex
                xs12
                class="text-size-large pb-2 px-2"
              >
                <b>Order ID: </b> {{ formData.order.theOrderID }}
              </v-flex>

              <v-flex
                v-if="!fromCustomer"
                xs12
                class="text-size-large pb-2 px-2"
              >
                <b>Customer: </b> {{ formData.order.full_name }}
              </v-flex>

              <v-flex
                xs12
                class="px-2"
              >
                <v-text-field
                  label="Note *"
                  v-model="formData.note"
                  :error-messages="errors.collect('Note')"
                  v-validate="'required'"
                  data-vv-name="Note"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeDialog()"
              outline
              color="normal"
            >Cancel</v-btn>
            <v-btn
              type="submit"
              :loading="loading"
              style="height:auto; margin-right: 2%"
              outline
              color="success"
            >
              {{ isUpdate ? 'Save' : 'Add' }}
            </v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Axios from 'axios'
import swal from 'sweetalert'

export default {
  props: {
    addEditOrderCaseModal: { type: Boolean, default: false },
    formData: { type: Object, default: () => { } },
    isUpdate: { type: Boolean, default: false },
    fromCustomer: { type: Boolean, default: false }
  },

  data() {
    return {
      loading: false
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      let url = 'api/order-case'
      if (this.fromCustomer) {
        url = 'api/order-case/customer-store'
      }

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            Axios.put(`${url}/${this.formData.order_case_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: 'Updated',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch(error => {
                swal('Error', `${error.response.data.message}`, 'error')
              })
          } else {
            Axios.post(url, this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
              .then(() => {
                swal({
                  title: 'Added',
                  text: '',
                  icon: 'success',
                  timer: 1500,
                  buttons: false
                })
                this.$emit('resetTable')
                this.closeDialog()
              })
              .catch(error => {
                swal('Error', `${error.response.data.message}`, 'error')
              })
          }
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/orderCase/addEditOrderCase.vue